import { render, staticRenderFns } from "./RowNewSection.vue?vue&type=template&id=db849f7c&scoped=true&"
import script from "./RowNewSection.vue?vue&type=script&lang=js&"
export * from "./RowNewSection.vue?vue&type=script&lang=js&"
import style0 from "./RowNewSection.vue?vue&type=style&index=0&id=db849f7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db849f7c",
  null
  
)

export default component.exports